import { css } from '@emotion/react'
import { stripUnit } from 'polished'

import { Breadcrumb } from '../components/Breadcrumbs/Breadcrumbs.styles'

import fluidRange from './fluidRange'

/**
 * @param {'Narrow'|'Full'|'Breakout'} [key='Full']
 * @returns {'960px'|'1200px'|'1320px'}
 */
function getWidthPadding(key = 'Full') {
  switch (key) {
    case 'Narrow':
      return '960px'
    case 'Breakout':
      return '1320px'
    case 'Full':
    default:
      return '1200px'
  }
}

export const WidthContainer = ({ theme, width }) => {
  const dtp = getWidthPadding(width)
  return css`
    ${fluidRange('padding-left', [
      stripUnit(theme?.spacing?.lg),
      stripUnit(theme?.spacing?.xl),
    ])};
    ${fluidRange('padding-right', [
      stripUnit(theme?.spacing?.lg),
      stripUnit(theme?.spacing?.xl),
    ])};

    @media (min-width: ${`${
        stripUnit(dtp) + stripUnit(theme?.spacing?.max)
      }px`}) {
      padding-right: ${`calc((100% - ${dtp}) / 2)`};
      padding-left: ${`calc((100% - ${dtp}) / 2)`};
    }
  `
}

export const ColorDeterminer = ({
  theme,
  backgroundColor,
  splitBackgroundColor,
  textColor,
  mobileTextColor,
  mobileTextColorEnd,
}) => {
  if (
    !backgroundColor &&
    !splitBackgroundColor &&
    !textColor &&
    !mobileTextColor
  )
    return false
  const { base } = theme.colors.dark
  const bg =
    backgroundColor === 'Prominent' ? 'primary' : backgroundColor?.toLowerCase()
  const bgObject = theme?.colors[bg]
  const contentfulDesktopColor = textColor?.toLowerCase()
  const contentfulMobileColor = mobileTextColor?.toLowerCase()
  const finalTextColor =
    theme?.colors?.[contentfulDesktopColor]?.base.hex ||
    theme?.backgroundColors?.[bg]?.textColor ||
    theme?.colors?.[bg]?.base?.readable ||
    theme?.colors.dark.base.hex
  const finalMobileTextColor =
    theme?.colors?.[contentfulMobileColor]?.base?.hex ||
    theme?.backgroundColors?.[bg]?.textColor ||
    theme?.colors.dark.base.hex
  let boxShadow
  if (bg === 'dark' || bg === 'black') {
    boxShadow = '0 4px 8px #22232300'
  } else {
    boxShadow = `${
      theme?.backgroundColors?.[bg]?.boxShadow ||
      theme?.shadow ||
      '0 4px 8px #d8dcdf'
    }`
  }

  return css`
    color: ${finalTextColor};
    background-color: ${bgObject?.base?.hex} !important;

    a,
    a:visited {
      color: ${finalTextColor};
    }

    ${Boolean(mobileTextColor) &&
    `
      @media (max-width: ${mobileTextColorEnd === 'lg' ? '939px' : '539px'}) {
        color: ${finalMobileTextColor} !important;

        a {
          color: ${finalMobileTextColor};
        }

        .leshen-variable-content {
          .content {
            color: ${finalMobileTextColor} !important;
          }
        }
      }
    `}

    .leshen-package-card {
      .wrapper {
        box-shadow: ${boxShadow} !important;
      }
    }

    .leshen-variable-content {
      .content {
        color: ${finalTextColor || theme?.colors.dark.base.hex};
      }
    }

    .countdown-block {
      border: 1px solid ${finalTextColor || theme?.colors.dark.base.hex};
    }

    ${Breadcrumb} {
      &:link,
      :visited {
        color: ${base.readable};
      }
    }
  `
}
